export default "__VITE_ASSET__DgYWPNK$__"